// extracted by mini-css-extract-plugin
export default {"container":"n3KBuKhceSNmFWn0y8od","row":"uLQpuoKOj8p59r_Ulx13","title":"BLdpFNO75UI3g2yjW6pd"};